import React                     from 'react';
import contrast                  from 'contrast';
import classNames                from 'classnames';
import { utc, UTC }              from 'rewire-common';
import { Observe }               from 'rewire-core';
import { WithStyle, withStyles } from 'rewire-ui';
import { utcDateToLocalDate }    from '../utility/DateUtils';
import Button                    from '@material-ui/core/Button';
import { Theme }                 from '@material-ui/core/styles';
import NavigateBeforeIcon        from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon          from '@material-ui/icons/NavigateNext';
import Calendar                  from 'react-big-calendar';
import moment                    from 'moment';
import withDragAndDrop           from 'react-big-calendar/lib/addons/dragAndDrop/';
import GeneratorCalendarModel, {ITemplateCalendarEvent} from './GeneratorCalendarModel';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import  './rbcStyles.css';

const localizer   = Calendar.momentLocalizer(moment);
const DnDCalendar = withDragAndDrop(Calendar);

const generatorCalendarToolbarStyles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    padding: '10px',
    justifyContent: 'space-between',
  },
  dateButton: {
    textTransform: 'none',
    // fontSize: '0.8125em',
  },
  dateNavContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '160px',
    margin: '0px 10px',
  },
  monthTitle: {
    margin: '0px 5px',
    textAlign: 'center',
    width: '100%',
  },
  navButton: {
    padding: '2px',
    minWidth: '0px',
    fontSize: '0.875em',
  },
});

interface IGeneratorCalendarToolbarProps {
  date:       Date;
  view:       string;
  views:      string[];
  label:      JSX.Element;
  localizer?: object;

  onNavigate(action: any): void;
  onView(view: any):       void;
}

type GeneratorCalendarToolbarProps = WithStyle<ReturnType<typeof generatorCalendarToolbarStyles>, IGeneratorCalendarToolbarProps>;

export const GeneratorCalendarToolbar = (model: GeneratorCalendarModel) => withStyles(generatorCalendarToolbarStyles, class extends React.Component<GeneratorCalendarToolbarProps> {
  constructor(props: GeneratorCalendarToolbarProps) {
    super(props);
  }

  shouldComponentUpdate(nextProps: IGeneratorCalendarToolbarProps) {
    return (nextProps.label !== this.props.label);
  }

  navigate = (action: string) => () => {
    this.props.onNavigate(action);
  };

  navigateToStartDate = () => {
    model.setCalendarDisplayDate(model.calendarStartDate);
  };

  render() {
    const {classes, label} = this.props;

    return (
      <div className={classes.root}>
        <Button variant='contained' size='small' className={classes.dateButton} onClick={this.navigateToStartDate}>
          Start Date
        </Button>
        <div className={classes.dateNavContainer}>
          <Button className={classes.navButton} onClick={this.navigate('PREV')}>
            <NavigateBeforeIcon />
          </Button>
          <span className={classes.monthTitle}>{label}</span>
          <Button className={classes.navButton} onClick={this.navigate('NEXT')}>
            <NavigateNextIcon />
          </Button>
        </div>
        <Button variant='contained' size='small' className={classes.dateButton} onClick={this.navigate('TODAY')}>
          Today
        </Button>
      </div>
    );
  }
});

const generatorCalendarDateCellWrapperStyles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    flex: '1 0 0',
    overflow: 'hidden',
    borderLeft: '1px solid #bbb',
    borderTop: '1px solid #bbb',
    '&:first-child': {
      borderLeft: 'none',
    },
  },
  disabled: {
    backgroundColor: '#e5e5e5',
    borderLeftColor: '#bbb',
    borderTopColor: '#bbb',
  },
});

interface IGeneratorCalendarDateCellWrapperProps {
  value: Date;
  children: JSX.Element;
}

type GeneratorCalendarDateCellWrapperProps = WithStyle<ReturnType<typeof generatorCalendarDateCellWrapperStyles>, IGeneratorCalendarDateCellWrapperProps>;

export const GeneratorCalendarDateCellWrapper = (model: GeneratorCalendarModel) => withStyles(generatorCalendarDateCellWrapperStyles, class extends React.Component<GeneratorCalendarDateCellWrapperProps> {
  constructor(props: GeneratorCalendarDateCellWrapperProps) {
    super(props);
  }

  shouldComponentUpdate(nextProps: IGeneratorCalendarDateCellWrapperProps) {
    return (
      (nextProps.value    !== this.props.value) ||
      (nextProps.children !== this.props.children)
    );
  }

  render() {
    return <Observe render={() => {
      const {classes, children, value} = this.props;
      const utcVal = utc(utcDateToLocalDate(value));

      return (
        <div className={classNames(classes.root, (!model.dateIsWithinCurrentMonth(utcVal) || !model.isValidCalendarDate(utcVal)) && classes.disabled)}>{children}</div>
      );
    }} />;
  }
});

const generatorCalendarMonthViewHeaderStyles = (_theme: Theme) => ({
});

interface IGeneratorCalendarMonthViewHeaderProps {
  date: Date;
  localizer: object;
  label: string;
}

type GeneratorCalendarMonthViewHeaderProps = WithStyle<ReturnType<typeof generatorCalendarMonthViewHeaderStyles>, IGeneratorCalendarMonthViewHeaderProps>;

export const GeneratorCalendarMonthViewHeader = withStyles(generatorCalendarMonthViewHeaderStyles, class extends React.Component<GeneratorCalendarMonthViewHeaderProps> {
  constructor(props: GeneratorCalendarMonthViewHeaderProps) {
    super(props);
  }

  shouldComponentUpdate(nextProps: IGeneratorCalendarMonthViewHeaderProps) {
    return (nextProps.label !== this.props.label);
  }

  render() {
    const {label} = this.props;

    return (
      <span>{label}</span>
    );
  }
});

const generatorCalendarMonthViewDateHeaderStyles = (_theme: Theme) => ({
  dateCell: {
    paddingTop: '2px',
    paddingRight: '4px',
  },
  startDate: {
    background: '#eaf6ff',
  },
});

interface IGeneratorCalendarMonthViewDateHeaderProps {
  date: Date;
  label: string;
}

type GeneratorCalendarMonthViewDateHeaderProps = WithStyle<ReturnType<typeof generatorCalendarMonthViewDateHeaderStyles>, IGeneratorCalendarMonthViewDateHeaderProps>;

export const GeneratorCalendarMonthViewDateHeader = (model: GeneratorCalendarModel) => withStyles(generatorCalendarMonthViewDateHeaderStyles, class extends React.Component<GeneratorCalendarMonthViewDateHeaderProps> {
  constructor(props: GeneratorCalendarMonthViewDateHeaderProps) {
    super(props);
  }

  shouldComponentUpdate(nextProps: IGeneratorCalendarMonthViewDateHeaderProps) {
    return (
      (nextProps.date.getTime() !== this.props.date.getTime()) ||
      (nextProps.label          !== this.props.label)
    );
  }

  render() {
    return <Observe render={() => {
      const {classes, label, date} = this.props;
      const labelDateStr           = utc(utcDateToLocalDate(date)).toDateString();
      const isStartDate            = labelDateStr === model.calendarStartDate.toDateString() && model.dateIsWithinCurrentMonth(model.calendarStartDate);

      return (
        <div className={classNames(classes.dateCell, isStartDate ? classes.startDate : undefined)}>{label}</div>
      );
    }} />;
  }
});

const templateCalendarEventComponentStyles = (_theme: Theme) => ({
  templateCalendarEvent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px',
    borderRadius: '3px',
    textTransform: 'none',
    lineHeight: '1.2',
  },
});

interface ITemplateCalendarEventComponentProps {
  event: ITemplateCalendarEvent;
}

type TemplateCalendarEventComponentProps = WithStyle<ReturnType<typeof templateCalendarEventComponentStyles>, ITemplateCalendarEventComponentProps>;

export const TemplateCalendarEventComponent = withStyles<ITemplateCalendarEventComponentProps,unknown>(templateCalendarEventComponentStyles, class extends React.Component<TemplateCalendarEventComponentProps> {
  constructor(props: TemplateCalendarEventComponentProps) {
    super(props);
  }

  shouldComponentUpdate(nextProps: ITemplateCalendarEventComponentProps) {
    return (
      (nextProps.event.title      !== this.props.event.title) ||
      (nextProps.event.color      !== this.props.event.color) ||
      (nextProps.event.templateId !== this.props.event.templateId)
    );
  }

  render() {
    const {classes, theme, event} = this.props;
    const bgColor     = event.color || theme?.palette.dialogPrimary.main;
    const textColor   = contrast(bgColor) === 'light' ? theme?.palette.common.black : theme?.palette.common.white;
    const borderColor = textColor === theme?.palette.common.black ? textColor : bgColor;

    if (!event.templateId) {
      return null;
    }

    return (
      <div title={event.tooltip} className={classes.templateCalendarEvent} style={{border: `1px solid ${borderColor}`, backgroundColor: bgColor, color: textColor}}>{event.title}</div>
    );
  }
});

const styles = (_theme: Theme) => ({
  root: {
    fontSize: '12px',
    position: 'relative',
    '&:focus': {
      outline: 0,
    },
  },
  calendar: {
    height: '400px',
    border: '1px solid #bbb',
  },
  customEvent: {
    padding: '2px',
    backgroundColor: 'transparent !important',
    borderRadius: '0px',
    textAlign: 'center',
    '&:focus': {
      outline: 0,
    },
  },
  addEventButton: {
    position: 'absolute',
    top: '10px',
    left: '10px',
    textTransform: 'none',
  },
});

interface IGeneratorCalendarProps {
  model: GeneratorCalendarModel;
  classes?: any;
  onDropFromOutside?: ({start, end, allDay}: {start: Date, end: Date, allDay: boolean}) => void;
  onDragOver?: (evt: DragEvent) => void;
}

type GeneratorCalendarProps = WithStyle<ReturnType<typeof styles>, IGeneratorCalendarProps>;

class GeneratorCalendar extends React.Component<GeneratorCalendarProps> {
  constructor(props: GeneratorCalendarProps) {
    super(props);
  }

  handleKeyDown = (evt: React.KeyboardEvent<any>) => {
    switch (evt.key) {
      case 'Delete':
        if (this.props.model.selectedTemplateCalendarEvent) {
          this.props.model.removeEvent(this.props.model.selectedTemplateCalendarEvent);
          this.props.model.setSelectedEvent();
        }
        break;
      default:
        break;
    }
  };

  customEventPropGetter = (_event: ITemplateCalendarEvent, _start: Date, _end: Date, _isSelected: boolean) => {
    return {
      className: this.props.classes.customEvent,
    };
  };

  startAccessor = (event: ITemplateCalendarEvent) => {
    return event.start instanceof UTC ? event.start.toUTCDate() : event.start;
  };

  endAccessor = (event: ITemplateCalendarEvent) => {
    return event.end instanceof UTC ? event.end.toUTCDate() : event.end;
  };

  onEventDrop = ({event, start, end}: {event: ITemplateCalendarEvent, start: Date, end: Date, allDay: boolean}) => {
    const utcStartVal = utc(utcDateToLocalDate(start));
    const utcEndVal   = utc(utcDateToLocalDate(end));
    this.props.model.updateEvents(event, utcStartVal, utcEndVal);
  };

  onNavigate = (date: Date, _view: string, _action: string) => {
    const utcVal = utc(utcDateToLocalDate(date)).startOfDay();
    this.props.model.setCalendarDisplayDate(utcVal);
  };

  onDoubleClickEvent = (_event: ITemplateCalendarEvent, _e: any) => {
  };

  onSelectEvent = (event: ITemplateCalendarEvent, _e: any) => {
    this.props.model.setSelectedEvent(event);
  };

  draggableAccessor = (event: ITemplateCalendarEvent) => {
    return this.props.model.canDrag(event);
  };

  render() {
    const {classes, onDropFromOutside, onDragOver} = this.props;

    return <Observe render={() => (
      <div className={classes.root} tabIndex={0} onKeyDown={this.handleKeyDown}>
        <DnDCalendar
          key={this.props.model.calendarDisplayDate.toDateString()}
          className={classes.calendar}
          views={['month']}
          defaultView='month'
          localizer={localizer}
          toolbar={true}
          events={this.props.model.displayedTemplateCalendarEvents}
          date={this.props.model.calendarDisplayDate.toUTCDate()}
          selected={this.props.model.selectedTemplateCalendarEvent}
          onSelectEvent={this.onSelectEvent}
          onDoubleClickEvent={this.onDoubleClickEvent}
          onNavigate={this.onNavigate}
          onEventDrop={this.onEventDrop}
          onDropFromOutside={onDropFromOutside}
          onDragOver={onDragOver}
          tooltipAccessor={'name'}
          draggableAccessor={this.draggableAccessor}
          resizableAccessor={(_event: ITemplateCalendarEvent) => false}
          startAccessor={this.startAccessor}
          endAccessor={this.endAccessor}
          eventPropGetter={this.customEventPropGetter}
          getDrilldownView={(_targetDate: Date, _currentViewName: string, _configuredViewNames: string[]) => null}
          components={{event: TemplateCalendarEventComponent, dateCellWrapper: GeneratorCalendarDateCellWrapper(this.props.model), toolbar: GeneratorCalendarToolbar(this.props.model), month: {header: GeneratorCalendarMonthViewHeader, dateHeader: GeneratorCalendarMonthViewDateHeader(this.props.model)}}}
        />
      </div>
    )} />;
  }
}

export default withStyles<IGeneratorCalendarProps,unknown>(styles, GeneratorCalendar);
